/* eslint-disable-next-line import/prefer-default-export */
import { batch } from 'react-redux';

import { findComponentByFieldName } from '../../Helpers/components';
import { exposeEventToPartner } from '../../Helpers/events';
import {
  setAdvancePageStatus,
  setQuestionAndAnswers,
} from '../../Lib/redux/slices/sessionDataPopulation';
import { populateFormFieldSaga } from '../actionCreators';
import logToConsole from '../../Utils/logToConsole';

// eslint-disable-next-line import/prefer-default-export
export const parseSessionDataAndPopulateFormFields = ({
  sessionData,
  components,
  dispatch,
  iFrameId,
  countryCode,
  formId,
}) => {
  let shouldAttemptAdvancingToUnansweredQuestion = false;

  batch(() => {
    Object.keys(sessionData).forEach((fieldName) => {
      const value = sessionData[fieldName];
      const componentOrError = findComponentByFieldName(
        fieldName,
        value,
        components
      );

      if (componentOrError) {
        if (componentOrError.errorObject) {
          exposeEventToPartner({
            eventType: 'formError',
            eventObject: {
              ...componentOrError.errorObject,
              iFrameId,
              formId,
            },
            errorObject: {
              message: `Failed to populate form field`,
            },
          });
        } else {
          const { componentId } = componentOrError;
          const component = components[`component_${componentId}`];

          dispatch(
            populateFormFieldSaga({
              countryCode,
              value,
              iFrameId,
              formId,
              component,
            })
          );

          shouldAttemptAdvancingToUnansweredQuestion = [
            'textfield',
            'textarea',
            'select',
            'radios',
            'checkboxes',
          ].includes(componentOrError.fieldType);
        }
      }
    });
  });

  dispatch(setQuestionAndAnswers({ questionAndAnswers: sessionData }));
  if (shouldAttemptAdvancingToUnansweredQuestion === true) {
    setTimeout(() => {
      // On mobile devices, the transition happens twice if we don't use setTimeout here
      // setTimeout is ensuring that the current execution context is finished before trying to advance the page
      dispatch(setAdvancePageStatus({ advancePageStatus: 'start' }));
    }, 0);
  }
};

export const extractParentPageTrustedFormOutOfSessionData = (
  sessionData,
  trustedFormMappedAdmiralQuestionId,
  trustedFormQuestionText
) => {
  /*
   * If the incoming session data contains a key-value pair for the Trusted
   * Form question, extract it out of the session data object.
   *
   * Note: GOLD-710 will need to revert this by deleting this function and the
   * function call, as per the ACs of the stop gap solution GOLD-742 and of
   * GOLD-710 itself.
   */
  const hasTrustedFormCertificateBeenReceived =
    Object.prototype.hasOwnProperty.call(
      sessionData,
      trustedFormQuestionText
    ) ||
    Object.prototype.hasOwnProperty.call(
      sessionData,
      trustedFormMappedAdmiralQuestionId
    );
  if (hasTrustedFormCertificateBeenReceived) {
    // Deeply clones this object by value to then mutate its clone (prevents a linter param-reassign error)
    const filteredSessionData = {};
    logToConsole.info(
      '[TRUSTED FORM] Discarding Trusted Form Cert ID received from the parent page'
    );
    Object.keys(sessionData).forEach((property) => {
      if (
        property !== trustedFormMappedAdmiralQuestionId &&
        property !== trustedFormQuestionText
      ) {
        filteredSessionData[property] = sessionData[property];
      }
    });
    return filteredSessionData;
  }
  return sessionData;
};
